var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEGiftCardsRewardsMx = function SvgEGiftCardsRewardsMx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.107,
    height: 41.451,
    x: 1,
    y: 1,
    stroke: "#FE5000",
    strokeWidth: 2,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M17.898 0v43.451M0 20.726h26.553M44.658 20.726h8.449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE5000",
    d: "M42.283 26.211q0 2.167-1.426 3.564-1.397 1.398-3.935 1.654-.114 0-.114.114l.029 2.053q0 .285-.286.286h-1.254q-.285 0-.285-.286l.028-2.053q0-.114-.114-.114-2.595-.285-4.05-1.682-1.453-1.425-1.453-3.622v-.884q0-.285.285-.285h1.283q.285 0 .285.285v.77q0 1.655 1.283 2.68 1.312.999 3.593.999 2.053 0 3.137-.913 1.083-.94 1.083-2.48 0-.999-.513-1.711-.485-.714-1.511-1.34-1.027-.628-2.937-1.455-2.053-.855-3.165-1.483a6 6 0 0 1-1.797-1.653q-.684-1.027-.684-2.567 0-2.196 1.34-3.479 1.34-1.31 3.707-1.54.114 0 .114-.113l-.029-2.225q0-.285.286-.285h1.226q.285 0 .285.285l-.029 2.253q0 .114.114.114 2.51.285 3.935 1.711 1.426 1.425 1.426 3.65v.627q0 .285-.285.285h-1.34q-.285 0-.285-.285v-.513q0-1.654-1.226-2.709-1.227-1.055-3.394-1.055-1.91 0-2.937.827t-1.026 2.395q0 1.027.485 1.711.513.655 1.425 1.17.942.483 2.88 1.282 1.968.855 3.166 1.597 1.226.741 1.938 1.825.742 1.056.742 2.595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FE5000",
    d: "M6.556 13.5h11.999M6.556 18.5h11.999M6.556 26.5h11.999M6.556 31.5h11.999"
  })));
};
export default SvgEGiftCardsRewardsMx;